var render = function render(_c,_vm){return _c('v-content',{staticClass:"app-content",class:_vm.props.center ? 'app-content--center' : ''},[_c('v-container',{staticClass:"app-content__container",attrs:{"fluid":""}},[_c('v-slide-x-transition',{attrs:{"appear":"","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }